import React from 'react';
import { Icons } from "./icons.constants";
import AdminUser from '../../asset/svg/AdminUser';
// import AnalyticIconSidebar from '../../asset/svg/AnalyticIconSidebar';
import AnalyticIconSidebar from '../../asset/svg/AnalyticIconSidebar';
import Merchant from '../../asset/svg/Merchant';
import SmartRouting from '../../asset/svg/SmartRouting';
import PaymentsIconSidebar from '../../asset/svg/PaymentsIconSidebar';
import RefundsIconSidebar from '../../asset/svg/RefundsIconSidebar';
import SettlementsSidebar from '../../asset/svg/SettlementsSidebar';
import DisputesSidebar from '../../asset/svg/DisputesSidebar';
// import IndividualPayoutsIconSidebar from '../../asset/svg/IndividualPayoutsIconSidebar';
import IndividualPayoutsIconSidebar from '../../asset/svg/IndividualPayoutIconSidebar';
import BulkPayoutIconSidebar from '../../asset/svg/BulkPayoutIconSidebar';
// import BulkPayoutIconSidebar from '../../asset/svg/BulkPayoutsIconSidebar';
import SettingsSidebar from '../../asset/svg/SettingsSidebar';
import OffersSidebar from '../../asset/svg/OffersSidebar';
import PlansSidebar from '../../asset/svg/PlansSidebar';
import SubscriptionSidebar from '../../asset/svg/SubscriptionsSidebar';
import PaymentLinksSidebar from '../../asset/svg/PaymentLinksSidebar';
import OverviewSidebar from '../../asset/svg/OverviewSidebar';
import CitiLogo from '../../asset/svg/CitiLogo';
import PluralLogo from '../../asset/svg/PluralLogo';
import ReportsIconSidebar from '../../asset/svg/ReportsIconSidebar';
import PartnerTransactionSidebar from '../../asset/svg/PartnerTransactionSidebar';
import PartnerSummary from '../../asset/svg/PartnerSummary';
import PartnerAllMerchant from '../../asset/svg/PartnerAllMerchant';
import BrandWallet from '../../asset/svg/BrandWallet';

interface SVGIconProps {
    icon: Icons;
    className?: string;
}

const SVGIcon: React.FC<SVGIconProps> = ({ icon }) => {
    switch (icon) {
        case Icons.adminUser:
            return <AdminUser />;

        case Icons.analyticSidebar:
            return <AnalyticIconSidebar />;

        case Icons.merchant:
            return <Merchant />;

        case Icons.paymentsSidebar:
            return <PaymentsIconSidebar />;

        case Icons.refundsSidebar:
            return <RefundsIconSidebar />;

        case Icons.settlementsSidebar:
            return <SettlementsSidebar />;

        case Icons.disputesSidebar:
            return <DisputesSidebar />;

        case Icons.individualPayoutsSidebar:
            return <IndividualPayoutsIconSidebar />;

        case Icons.bulkPayoutsSidebar:
            return <BulkPayoutIconSidebar />;
        
        case Icons.settingsSidebar:
            return <SettingsSidebar />;

        case Icons.offersSidebar:
            return <OffersSidebar />;

        case Icons.plansSidebar:
            return <PlansSidebar />;

        case Icons.subcriptionsSidebar:
            return <SubscriptionSidebar />;

        case Icons.paymentLinksSidebar:
            return <PaymentLinksSidebar />;

        case Icons.overviewSidebar:
            return <OverviewSidebar />;

        case Icons.citiLogo:
            return <CitiLogo />;

        case Icons.pluralLogo:
            return <PluralLogo />;

        case Icons.reportsSidebar:
            return <ReportsIconSidebar />;

        case Icons.partnerTransactionSidebar:
            return <PartnerTransactionSidebar />;

        case Icons.partnerSummary:
            return <PartnerSummary />;

        case Icons.partnerAllMerchant:
            return <PartnerAllMerchant />;
         
        case Icons.brandWalletSidebar:
            return <BrandWallet width={'22px'} />;    

        default:
            return <SmartRouting />;
    }
};

export default SVGIcon;
